import { SxType } from "@baseTypes/sx/sxTypes";

export const sx: SxType = {
    item: {
        position: 'relative',
        transition: 'all 0.3s ease',
        cursor: 'pointer',
        borderRadius: '8px',
        overflow: 'hidden',
        border: '2px solid transparent',
        '& .image-preview-custom': {
            height: '100%',
            width: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            transition: 'transform 0.3s',
        },
        
        '&:hover .image-preview-custom': {
            transform: 'scale(1.03)',
        },
        
        '&.active': {
            boxShadow: '0 0 12px rgba(255, 0, 0, 0.7)',
            backgroundColor: '#ffeaea',
            border: '2px solid #ff4d4f',
        }
    }
};